import { render, staticRenderFns } from "./all-list.vue?vue&type=template&id=475c8e5e&scoped=true"
import script from "./all-list.vue?vue&type=script&lang=ts"
export * from "./all-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c8e5e",
  null
  
)

export default component.exports